function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8858 8.34216L22.6366 12.0931L21.0815 13.6481L17.1592 9.72576C16.4889 10.4578 16.2103 11.0467 15.8774 11.5542L19.5264 15.2033L17.9714 16.7582L14.6886 13.4755L0.133545 37.0003L17.8943 26.0116L14.8613 22.9786L16.4163 21.4235L19.8156 24.8228L21.737 23.634L17.9714 19.8684L19.5265 18.3134L23.6583 22.4453C24.2238 22.0954 22.23 23.329 26.3729 20.7656C28.2468 19.5821 29.4624 17.64 29.708 15.4373C29.9536 13.2347 29.1957 11.0726 27.6284 9.50533C25.251 7.12776 21.656 6.75206 18.8858 8.34216Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M34.7241 9.25313C33.9274 8.95895 33.6228 8.13183 33.8463 7.50242C34.7724 4.90413 32.2458 2.38281 29.6772 3.27085C28.8972 3.53541 27.8594 2.86113 27.6413 2.22029C26.3845 -1.27587 21.2786 -0.43438 21.2197 3.28478V5.26875C24.1392 4.863 27.1018 5.85242 29.1835 7.94996C31.2179 9.9843 32.2056 12.7881 31.8969 15.6472H33.5823C37.2807 15.5792 38.123 10.5533 34.7241 9.25313Z",
  fill: "white"
});

function SvgFarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarm);
export default __webpack_public_path__ + "static/media/farm.83a7e9a6.svg";
export { ForwardRef as ReactComponent };